import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import FAQManagementPage from './view/faq/FAQManagementPage'
import OrganizationSelectionModal from './view/org/OrganizationSelectionModal'
import SlipEditPopup from './view/hr/slip/SlipEditPopup'
// import SlipEditPanel from './view/hr/slip/SlipEditPanel'
import SlipDailyEmployeeTable from './view/hr/slip/SlipDailyEmployeeTable'
import SlipContractorTable from './view/hr/slip/SlipContractorTable'
import AutoPartViewer from './view/autoparts/AutoPartViewer'
import ReportContractorWage from './view/hr/report/ReportContractorWage'
import ReportFixingOrderPage from './view/report/ReportFixingOrderPage'
import ExcelEmployeeWage from './view/hr/report/ExcelEmployeeWage'
import ReportPendingWork from './view/report/ReportPendingWork'
import ReportInvoice from './view/report/ReportInvoice'
import ReportShopPurchaseOrder from './view/report/ReportShopPurchaseOrder'
import ReportEmployee from './view/hr/report/ReportEmployee'
import ReportEmployeeAbsence from './view/hr/report/ReportEmployeeAbsence'
import ReportAdvanceSalary from './view/hr/report/ReportAdvanceSalary'
import ReportSummary from './view/hr/report/ReportSummary'
import ReportCashFlowRecord from './view/report/ReportCashFlowRecord'
import ReportPickup from './view/report/ReportPickup'
// import ReportMechanicWork from './view/report/ReportMechanicWork'
import ReportEmployeeAdvanceSalaryRecord from './view/hr/report/ReportEmployeeAdvanceSalaryRecord'
// import WageDataGrid from './view/workdoc/WageDataGrid'
import SWTWorkDocDamage from './view/workdoc/SWTWorkDocDamage'
import RCKWorkDocDamage from './view/workdoc/RCKWorkDocDamage'
import SWTWorkDocDamageFasttrack from './view/workdoc/SWTWorkDocDamageFasttrack'
import SWTNewCustomerButton from './view/workdoc/SWTNewCustomerButton'
import SWTCustomerPage from './view/workdoc/SWTCustomerPage'
import SWTNewCarButton from './view/workdoc/SWTNewCarButton'
import SWTNewCarTypeButton from './view/workdoc/SWTNewCarTypeButton'
import ReportWork from './view/report/ReportWork'
import ReportRefixedWork from './view/report/ReportRefixedWork'
import ReportReceptionWork from './view/report/ReportReceptionWork'
import ReportJobControlBoard from './view/report/ReportJobControlBoard'
import Plan from './view/workdoc/plan/Plan'
import MessageMenu from './view/menu/MessageMenu'
import MessagePopup from './view/menu/MessagePopup'
import InvoiceStatusMenuButton from './view/menu/invoicestatus/InvoiceStatusMenuButton'
import PriceCompare from './view/workdoc/pricecompare/PriceCompare'
import ReportPurchaseOrderPage from './view/report/ReportPurchaseOrderPage'
import ReportQuotationPage from './view/report/ReportQuotationPage'
import ReportInvoicePage from './view/report/ReportInvoicePage'
import ReportReceiptPage from './view/report/ReportReceiptPage'
import ReportTaxinvoicePage from './view/report/ReportTaxinvoicePage'
import ReportCreditNotePage from './view/report/ReportCreditNotePage'
import ReportDebitNotePage from './view/report/ReportDebitNotePage'
import ReportBillingNotePage from './view/report/ReportBillingNotePage'
import ReportReceiptVoucherPage from './view/report/ReportReceiptVoucherPage'
import ReportPaymentVoucherPage from './view/report/ReportPaymentVoucherPage'
import ReportCashbillPage from './view/report/ReportCashbillPage'
import ReportPettyCashPage from './view/report/ReportPettyCashPage'
import ReportKKCProfit from './view/report/ReportKKCProfit'
import ReportKKCPurchaseOrderSummary from './view/report/ReportKKCPurchaseOrderSummary'
import PettyCashDoc from './view/cashflow/PettyCashDoc'
import WorkJobControlPage from './view/workdoc/jobcontrol/WorkJobControlPage'
import WorkJobOfficeControlPage from './view/workdoc/officecontrol/WorkJobOfficeControlPage'
import FixingOrderDoc from './view/workdoc/jobcontrol/FixingOrderDoc'
import WorkTimeRecord from './view/workdoc/jobcontrol/WorkTimeRecord'
import WorkDocGenForm from './view/workdoc/WorkDocGenForm'
import WorkDocStock from './view/workdoc/WorkDocStock'
import PrintFixingOrderDoc from './view/print/PrintFixingOrderDoc'
import PrintWorkJobPhoto from './view/print/PrintWorkJobPhoto'
import PrintReportPOAndExpense from './view/print/PrintReportPOAndExpense'
import PrintReportKKCAllYearProfit from './view/print/PrintReportKKCAllYearProfit'
import PrintReportKKCAllYearIncomeOverview from './view/print/PrintReportKKCAllYearIncomeOverview'
import PrintKKCTaxInvoiceCoverNote from './view/print/PrintKKCTaxInvoiceCoverNote'
import PrintKKCTaxInvoiceCoverNoteInsurer from './view/print/PrintKKCTaxInvoiceCoverNoteInsurer'
import PrintKKCBillingNoteCompany from './view/print/PrintKKCBillingNoteCompany'
import PrintKKCBillingNoteInsurer from './view/print/PrintKKCBillingNoteInsurer'
import PrintKKCDamagePartCheckList from './view/print/PrintKKCDamagePartCheckList'
import PrintPurchaseReceivedDoc from './view/print/PrintPurchaseReceivedDoc'
import PrintTwoPagesInvoiceDoc from './view/print/PrintTwoPagesInvoiceDoc'
import PrintTwoPagesTaxInvoiceDoc from './view/print/PrintTwoPagesTaxInvoiceDoc'
import PrintTwoPagesCashBillDoc from './view/print/PrintTwoPagesCashBillDoc'
import PrintTwoPagesReceiptDoc from './view/print/PrintTwoPagesReceiptDoc'
import PrintTwoPagesPurchaseOrderDoc from './view/print/PrintTwoPagesPurchaseOrderDoc'
import PrintReportTJYIncentiveExpenseInsurance from './view/print/PrintReportTJYIncentiveExpenseInsurance'
import PrintReportCashflowRecord from './view/print/PrintReportCashflowRecord'
import PrintWCSParkingCarDoc from './view/print/wcs/PrintWCSParkingCarDoc'
import PrintWCSCheckingCarDoc from './view/print/wcs/PrintWCSCheckingCarDoc'
import PrintWCSFixingOrderDoc from './view/print/wcs/PrintWCSFixingOrderDoc'
import PrintBHLParkingCarDoc from './view/print/bhl/PrintBHLParkingCarDoc'
import PrintBHLFixingListOnCarDoc from './view/print/bhl/PrintBHLFixingListOnCarDoc'
import PrintBNPInvoiceDoc from './view/print/bnp/PrintBNPInvoiceDoc'
import PrintBNPTaxInvoiceDoc from './view/print/bnp/PrintBNPTaxInvoiceDoc'
import PrintSSRInvoiceDoc from './view/print/ssr/PrintSSRInvoiceDoc'
import PrintKKCPhotobook from './view/print/PrintKKCPhotobook'
import PrintReportEmployee from './view/print/PrintReportEmployee'
import PrintVoucherDoc from './view/print/PrintVoucherDoc'
import PrintCreditDebitDoc from './view/print/PrintCreditDebitDoc'
import PrintReportStockCard from 'view/print/stock/PrintReportStockCard'
import PrintReportStockCardCost from 'view/print/stock/PrintReportStockCardCost'
import PrintReportStockBalanceValue from 'view/print/stock/PrintReportStockBalanceValue'
import ReportContractor from './view/report/ReportContractor'
import InsurerPageModal from './view/insurer/InsurerPageModal'
import InsurerPage from './view/insurer/InsurerPage'
import SupplierPageModal from './view/po/SupplierPageModal'
import SupplierPage from './view/po/SupplierPage'
import SelectParts from './view/po/SelectParts'
import WorkJobTimeTable from './view/workdoc/jobcontrol/WorkJobTimeTable'
import ReportPage from './view/report/ReportPage'
import ReportCategoryPage from './view/report/ReportCategoryPage'
import TutorialPage from './view/tutorial/TutorialPage'
import WorkDocPurchaseOrder from './view/workdoc/WorkDocPurchaseOrder'
import WorkDocAttachmentDoc from './view/workdoc/WorkDocAttachmentDoc'
import WorkDocTimeline from './view/workdoc/WorkDocTimeline'
import WorkDocMessage from './view/workdoc/WorkDocMessage'
// import MyPlan from './view/workdoc/plan/MyPlan'
import TestPlan from './view/workdoc/plan/TestPlan'
import StockManagementPage from './view/stock/StockManagementPage'
import StockTyreManagementPage from './view/tyre/stock/StockTyreManagementPage'
import StockPainterBorrowingRecord from './view/stock/StockPainterBorrowingRecord'
import StockToolBorrowingRecord from './view/stock/StockToolBorrowingRecord'
import StockProductUsageRecord from './view/stock/StockProductUsageRecord'
import CashFlowRecord from './view/cashflow/CashFlowRecord'
import IncentiveExpenseRecord from './view/cashflow/IncentiveExpenseRecord'
import IncentivePayeeButton from './view/cashflow/IncentivePayeeButton'
import StockMixPaintReport from './view/stock/StockMixPaintReport'
import StockRequestReport from './view/stock/StockRequestReport'
import StockRequestDoc from './view/stock/StockRequestDoc'
import StockAnyExportReport from './view/stock/StockAnyExportReport'
import PrintPreview from './view/print/PrintPreview'
import PrintReportJobControlBoard from './view/print/PrintReportJobControlBoard'
import PrintParkingCarDoc from './view/print/PrintParkingCarDoc'
import PrintQuotationDoc from './view/print/PrintQuotationDoc'
import PrintQuotationDoc2 from './view/print/PrintQuotationDoc2'
import PrintExcelQuotationDoc from 'view/print/kkc/PrintExcelQuotationDoc'
import PrintWorkJobTimeTable from './view/print/PrintWorkJobTimeTable'
import PrintWorkOfficeJobTimeTable from './view/print/PrintWorkOfficeJobTimeTable'
import PrintSSTWorkCoverFileDoc from './view/print/sst/PrintSSTWorkCoverFileDoc'
import PrintSSTFixingListOnCarDoc from './view/print/sst/PrintSSTFixingListOnCarDoc'
import PrintCheckingDamageDoc from './view/print/PrintCheckingDamageDoc'
import PrintSSTParkingCarDoc from './view/print/sst/PrintSSTParkingCarDoc'
import PrintTNKBigJobDoc from './view/print/tnk/PrintTNKBigJobDoc'
import PrintSSTBigJobDoc from './view/print/sst/PrintSSTBigJobDoc'
import PrintZongBigJobDoc from 'view/print/zong/PrintZongBigJobDoc'
import PrintZongInvoiceDoc from 'view/print/zong/PrintZongInvoiceDoc'
import PrintSSTBillingNoteInsurer from './view/print/sst/PrintSSTBillingNoteInsurer'
import PrintShippingLabel from './view/print/PrintShippingLabel'
import PrintTLGTaxInvoiceCoverNoteInsurer from './view/print/tlg/PrintTLGTaxInvoiceCoverNoteInsurer'
import PrintTLGInvoiceDoc from './view/print/tlg/PrintTLGInvoiceDoc'
import PrintSSTTaxInvoiceCoverNoteInsurer from './view/print/sst/PrintSSTTaxInvoiceCoverNoteInsurer'
import PrintSSTWarrantyWorkDoc from './view/print/sst/PrintSSTWarrantyWorkDoc'
// import PrintZongTaxInvoiceConverNoteInsurer from 'view/print/zong/PrintZongTaxInvoiceConverNoteInsurer'
import PrintZongTaxInvoiceCoverNoteInsurer from 'view/print/zong/PrintZongTaxInvoiceCoverNoteInsurer'
import PrintTJYSalarySlipDoc from './view/print/PrintTJYSalarySlipDoc'
import PrintReportStockCheck from './view/print/PrintReportStockCheck'
import PrintCarSummaryDoc from './view/print/PrintCarSummaryDoc'
import PrintNDMFixingListOnCarDoc from './view/print/ndm/PrintNDMFixingListOnCarDoc'
import PrintKKCContractorQuotationDoc from './view/print/PrintKKCContractorQuotationDoc'
import PrintReportContractorWageTable from './view/print/PrintReportContractorWageTable'
import PrintReportContractorWageSlip from './view/print/PrintReportContractorWageSlip'
import PrintSlipContractorDetail from './view/print/PrintSlipContractorDetail'
import PrintReportSummarySlip from './view/print/PrintReportSummarySlip'
import PrintReportKKCIncome from './view/print/PrintReportKKCIncome'
import PrintReportKKCBalance from './view/print/PrintReportKKCBalance'
import PrintReportKKCReceivableCash from './view/print/PrintReportKKCReceivableCash'
import PrintReportKKCBillingNoteReceivable from './view/print/PrintReportKKCBillingNoteReceivable'
import PrintReportKKCPurchaseOrderSummary from './view/print/PrintReportKKCPurchaseOrderSummary'
import PrintWorkQCDoc from './view/print/PrintWorkQCDoc'
import PrintKKCWorkQCDoc from './view/print/PrintKKCWorkQCDoc'
import PrintTNKWorkCoverFileDoc from './view/print/tnk/PrintTNKWorkCoverFileDoc'
import PrintReportPickup from './view/print/PrintReportPickup'
import PrintReportCommissionMechanic from './view/print/employee/PrintReportCommissionMechanic'
import PrintReportWork from "./view/print/PrintReportWork";
import PrintReportWorking from './view/print/employee/PrintReportWorking'
import PrintReportWorkingDetail from './view/print/employee/PrintReportWorkingDetail'
import PrintReportProductTransactionImport from './view/print/stock/PrintReportProductTransactionImport'
import PrintReportProductTransactionRequestPurchase from './view/print/stock/PrintReportProductTransactionRequestPurchase'
import PrintReportProductBalance from './view/print/stock/PrintReportProductBalance'
import PrintReportPOReceivedProduct from './view/print/po/PrintReportPOReceivedProduct'
import PrintReportSalesTax from './view/print/finance/PrintReportSalesTax'
import PrintReportPostPayment from './view/print/finance/PrintReportPostPayment'
import PrintReportAccountReceiable from './view/print/finance/PrintReportAccountReceiable'
import PrintReportAccountReceiableDetail from './view/print/finance/PrintReportAccountReceiableDetail'
import PrintReportSummaryFixingWork from './view/print/fixing/PrintReportSummaryFixingWork'
import PrintReportFixingRefixed from './view/print/fixing/PrintReportFixingRefixed'
import PrintReportUnfinishedWork from './view/print/fixing/PrintReportUnfinishedWork'
import PrintReportUnfinishedWorkDetail from './view/print/fixing/PrintReportUnfinishedWorkDetail'
import PrintReportPostponeAppointment from './view/print/fixing/PrintReportPostponeAppointment'
import PrintReportWaitingQuotation from './view/print/fixing/PrintReportWaitingQuotation'
import PrintReportSummaryWork from './view/print/analysis/PrintReportSummaryWork'
import PrintReportSummaryWorkDetail from './view/print/analysis/PrintReportSummaryWorkDetail'
import PrintReportWorkDocPurchaseOrder from './view/print/PrintReportWorkDocPurchaseOrder'
import PrintReportSummaryOT from './view/print/hr/PrintReportSummaryOT'
import PrintReportSummaryNormalAbsence from './view/print/hr/PrintReportSummaryNormalAbsence'
import PrintReportSummaryDeductionAbsence from './view/print/hr/PrintReportSummaryDeductionAbsence'
import PrintSlipTableDoc from './view/print/hr/PrintSlipTableDoc'
import PrintReportConsumablesMaterial from './view/print/material/PrintReportConsumablesMaterial'
import PrintReportColor from './view/print/material/PrintReportColor'
import PrintReportColorDetail from './view/print/material/PrintReportColorDetail'
import PrintReportBalanceMaterial from './view/print/material/PrintReportBalanceMaterial'
import PrintReportStockMixPaint from './view/print/material/PrintReportStockMixPaint'
import PrintReportUsageVolumeTransactionRecord from './view/print/material/PrintReportUsageVolumeTransactionRecord'
import PrintReportJobCostSheet from './view/print/analysis/PrintReportJobCostSheet'
import PrintReportJobCostSheetDetail from './view/print/analysis/PrintReportJobCostSheetDetail'
import PrintReportQuotationMovement from './view/print/analysis/PrintReportQuotationMovement'
import PrintReportOutstandingIncomeSummary from './view/print/analysis/PrintReportOutstandingIncomeSummary'
import PrintReportOutstandingIncomeSummaryDetail from './view/print/analysis/PrintReportOutstandingIncomeSummaryDetail'
import PrintContinuousPaperConfig from './view/print/paperconfig/PrintContinuousPaperConfig'
import PdfContinuousPaper from './view/print/paperconfig/PdfContinuousPaper'
import PrintReportSummaryInsure from './view/print/analysis/PrintReportSummaryInsure'
import PrintPaymentNoteDoc from './view/print/PrintPaymentNoteDoc'
import PrintGeneralSlipDoc from './view/print/PrintGeneralSlipDoc'
// import PrintReportMechanicWork from './view/print/PrintReportMechanicWork'
import PrintSSTWorkQCDoc from './view/print/sst/PrintSSTWorkQCDoc'
import SWTNewColorButton from './view/workdoc/SWTNewColorButton'
import SWTNewInsurerButton from './view/workdoc/SWTNewInsurerButton'
import EmployeeCodeButton from './view/hr/EmployeeCodeButton'
import Tracker from './view/workdoc/qrtracker/Tracker'
import WorkTracker from './view/workdoc/qrtracker/WorkTracker'
import MainDashboard from './view/dashboard/MainDashboard';
import QuotationFileTreePage from './view/qo/QuotationFileTreePage'
import SWTWorkUpload from './view/workdoc/SWTWorkUpload'
import CarDamageContainer from './view/workdoc/CarDamageContainer';
import CarDamageDebug from 'view/debug/CarDamageDebug';
import PartItemTable from './view/book/PartItemTable'
import NewWageItemModal from './component/element/CarDamageForm/NewWageItemModal/NewWageItemModal';
import NewPartItemModal from './component/element/CarDamageForm/NewPartItemModal/NewPartItemModal';
import DatePickerModal from './component/element/DatePickerModal';
import RemarkRecordModal from './component/element/RemarkRecordModal';
import './index.css';
import 'icheck/skins/all.css'
import 'react-select/dist/react-select.css';
import 'bootstrap/dist/css/bootstrap.css';
import './asset/css/bf.css';
import MessageNoti from './view/menu/MessageNoti';
import RealtimeDebug from './view/debug/RealtimeDebug';
import AdminConfig from 'view/debug/AdminConfig'
import PermissionTable from 'view/permission/PermissionTable'
//import 'bootstrap/dist/css/bootstrap-theme.css';
import TermOfServiceModal from './view/tos/TermOfServiceModal'
import NotificationScheduleConfig from './view/notification/NotificationScheduleConfig'
import Calendar from 'view/calendar/Calendar'
import FixLevelConfig from './view/workdoc/fixlevel/FixLevelConfig'
import FixCommissionConfig from './view/workdoc/fixlevel/FixCommissionConfig'
import WorkPostponeAppointmentButton from './view/workdoc/WorkPostponeAppointmentButton'
import ConfigOfficeWorkflow from './view/admin/ConfigOfficeWorkflow'
import ConfigMechanicWorkflow from './view/admin/ConfigMechanicWorkflow'
import DetectOffline from 'view/notification/DetectOffline'
import ReportTyreRepairPage from './view/tyre/ReportTyreRepairPage'
import ReportTyreRetirePage from './view/tyre/ReportTyreRetirePage'
import ReportAssetVehiclePage from './view/tyre/report-asset-vehicle-page/ReportAssetVehiclePage'
import PrintTyreRepairDoc from './view/print/tyre/PrintTyreRepairDoc'
import PrintTyreRetireDoc from './view/print/tyre/PrintTyreRetireDoc'
import PreviewWorkDoc from './view/workdoc/preview/PreviewWorkDoc'
import LineMessagePage from './view/linemessage/LineMessagePage'
import SWTCreditInstallment from './view/workdoc/SWTCreditInstallment'
import PrintEmployeeWorkMonthlyReport from 'view/print/hr/PrintEmployeeWorkMonthlyReport'
import PrintDearTaxInvoiceDoc from 'view/print/dear/PrintDearTaxInvoiceDoc'
import PrintDearPartDisposebyReturn from 'view/print/dear/PrintDearPartDisposebyReturn'
import PrintDeliveryCarDoc from 'view/print/PrintDeliveryCarDoc'
import PrintPGAAppointmentQueueDoc from './view/print/pga/PrintPGAAppointmentQueueDoc'
import PrintPGAWorkCoverFileDoc from './view/print/pga/PrintPGAWorkCoverFileDoc' 
import PrintPGABorrowingBackupcarDoc from './view/print/pga/PrintPGABorrowingBackupcarDoc'
import PrintReportAnalysisWorkCustomCost from './view/print/analysis/PrintReportAnalysisWorkCustomCost'
import PrintReportAnalysisDeliveryEfficiency from './view/print/analysis/PrintReportAnalysisDeliveryEfficiency'
import PrintReceptionDoc from './view/print/PrintReceptionDoc'
import reduxMiddleware from 'react-block-ui/reduxMiddleware';

const Provider = require('react-redux').Provider;
const createStore = require('redux').createStore;
const applyMiddleware = require('redux').applyMiddleware;
const content = require('./reducer');
const store = createStore(content, applyMiddleware(reduxMiddleware));


export function   renderReactDOM(component,element) {
        return ReactDOM.render(
          <Provider {... { store }}><App>{component}</App></Provider>,
          element
        );
    }

export function   handlePage(urlParams){
      switch (urlParams["startPage"]) {   
        case 'PreviewWorkData':
          ReactDOM.render(
              <PreviewWorkDoc preview_id={urlParams['preview_id']} />,
              document.getElementById('root'),
          );
          break; 
        case "PrintEmployeeWorkMonthlyReport":
            ReactDOM.render(
                <PrintEmployeeWorkMonthlyReport year={urlParams['year']} month={urlParams['month']} em={urlParams['em']} />,
                document.getElementById('root')
            );
          break;  
        case "PrintParkingCarDoc":
          ReactDOM.render(<PrintParkingCarDoc mode={urlParams["mode"]} workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;
        case "PrintSSTParkingCarDoc":
          ReactDOM.render(<PrintSSTParkingCarDoc mode={urlParams["mode"]} workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;
        case "PrintSSTBigJobDoc":
          ReactDOM.render(<PrintSSTBigJobDoc workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;
        case "PrintSSTWarrantyWorkDoc":
            ReactDOM.render(<PrintSSTWarrantyWorkDoc workNo={urlParams["wo"]} />, document.getElementById('root'));
            break;          
        case "PrintTNKBigJobDoc":
          ReactDOM.render(<PrintTNKBigJobDoc workNo={urlParams["wo"]} />, document.getElementById('root'));
          break; 
        case "PrintZongBigJobDoc":
          ReactDOM.render(<PrintZongBigJobDoc workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;    
        case "PrintZongInvoiceDoc":
            ReactDOM.render( <PrintZongInvoiceDoc ivNo={urlParams['iv']} doc='invoice_doc'/>, document.getElementById('root'));
            break;          
        case "PrintZongTaxInvoiceDoc":
          ReactDOM.render( <PrintZongInvoiceDoc ivNo={urlParams['iv']} doc='taxinvoice_doc'  param='tiv'/>, document.getElementById('root'));
          break;
        case "PrintZongReceiptDoc":
          ReactDOM.render( <PrintZongInvoiceDoc ivNo={urlParams['iv']} doc='receipt_doc'  param='rc'/>, document.getElementById('root'));
          break;          
        case "PrintSSTWorkCoverFileDoc":
          ReactDOM.render(<PrintSSTWorkCoverFileDoc workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;
        case "PrintSSTFixingListOnCarDoc":
          ReactDOM.render(<PrintSSTFixingListOnCarDoc workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;
        case "PrintNDMFixingListOnCarDoc":
          ReactDOM.render(<PrintNDMFixingListOnCarDoc mode={urlParams["mode"]} workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;  
        case "PrintWorkJobPhoto":
          ReactDOM.render(
            <PrintWorkJobPhoto workNo={urlParams["wo"]} cat={urlParams["cat"]} />, document.getElementById('root')
          );
          break;
        case "PrintExcelQuotationDoc":
          ReactDOM.render(
            <PrintExcelQuotationDoc qoNo={urlParams["qo"]} fileId={urlParams["fileId"]}/>, document.getElementById('root')
          );
          break;  
        case "PrintQuotationDoc":
          ReactDOM.render(
            <PrintQuotationDoc qoNo={urlParams["qo"]} fileId={urlParams["fileId"]}/>, document.getElementById('root')
          );
          break;
        case "PrintQuotationDoc2":
          ReactDOM.render(
            <PrintQuotationDoc2 qoNo={urlParams["qo"]} fileId={urlParams["fileId"]}/>, document.getElementById('root')
          );
          break;   
        case "PrintWorkJobTimeTable":
          ReactDOM.render(<PrintWorkJobTimeTable mode={urlParams["mode"]} workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;
        case "PrintWorkOfficeJobTimeTable":
          ReactDOM.render(<PrintWorkOfficeJobTimeTable mode={urlParams["mode"]} workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;  
        // case "PrintReportJobControlBoard":
        //   ReactDOM.render(<PrintReportJobControlBoard control={urlParams["control"]} />, document.getElementById('root'));
        //   break;
        case "PrintReportJobControlBoard":
        renderReactDOM(<PrintReportJobControlBoard control={urlParams["control"]} {...urlParams} status={urlParams["status"]} />, document.getElementById('root'));
        break;
        case "WorkTracker":
          renderReactDOM(<WorkTracker debug={urlParams["debug"]} startTaskAuto={urlParams['startTaskAuto']==='true'} closeTimer={urlParams['closeTimer']}/>, document.getElementById('root'));
          break;
        case "PrintReportStockCheck":
          renderReactDOM(<PrintReportStockCheck stockType={urlParams["type"]} />,document.getElementById('root')); 
          break;
        case "PrintCarSummaryDoc":
          ReactDOM.render(<PrintCarSummaryDoc workNo={urlParams["wo"]} />, document.getElementById('root'));
          break;
        case "PrintKKCContractorQuotationDoc":
          ReactDOM.render(<PrintKKCContractorQuotationDoc workNo={urlParams["wo"]} employee_id={urlParams["employee_id"]}/>, document.getElementById('root'));
          break;
        case "PrintReportContractorWageTable":
          ReactDOM.render(<PrintReportContractorWageTable year={urlParams["year"]} month={urlParams["month"]} week={urlParams["week"]} />, document.getElementById('root'));
          break;
        case "PrintReportContractorWageSlip":
          ReactDOM.render(<PrintReportContractorWageSlip slipList={urlParams["slipList"]} year={urlParams["year"]} month={urlParams["month"]} week={urlParams["week"]} />, document.getElementById('root'));
          break;  
        case "PrintTJYSalarySlipDoc":
          ReactDOM.render(<PrintTJYSalarySlipDoc periodic={urlParams["periodic"]} emType={urlParams["em_type"]} em={urlParams["em"]} ss={urlParams["ss"]} />, document.getElementById('root'));
          break;
        case "PrintSlipContractorDetail":
          ReactDOM.render(<PrintSlipContractorDetail periodic={urlParams["periodic"]} em={urlParams["em"]} slipId={urlParams["ss"]} />, document.getElementById('root'));
          break;
        case "PrintReportSummarySlip":
          ReactDOM.render(<PrintReportSummarySlip year={urlParams["year"]} month={urlParams["month"]} between={urlParams["between"]} start={urlParams["start"]} end={urlParams["end"]}  />, document.getElementById('root'));
          break; 
        case "PrintReportKKCIncome":
          ReactDOM.render(<PrintReportKKCIncome year={urlParams["year"]} month={urlParams["month"]} q={urlParams["q"]} cat={urlParams["cat"]} />, document.getElementById('root'));
          break;
        case "PrintReportKKCBalance":
          ReactDOM.render(<PrintReportKKCBalance year={urlParams["year"]} month={urlParams["month"]} q={urlParams["q"]} cat={urlParams["cat"]} />, document.getElementById('root'));
          break; 
        case "PrintReportKKCReceivableCash":
          ReactDOM.render(<PrintReportKKCReceivableCash />, document.getElementById('root'));
          break;   
        case "PrintReportKKCBillingNoteReceivable":
          ReactDOM.render(<PrintReportKKCBillingNoteReceivable />, document.getElementById('root'));
          break;    
        case "PrintReportKKCAllYearProfit":
          ReactDOM.render(
            <PrintReportKKCAllYearProfit year={urlParams["year"]} typePrint={urlParams["type_print"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportKKCAllYearIncomeOverview":
          ReactDOM.render(
            <PrintReportKKCAllYearIncomeOverview year={urlParams["year"]} typePrint={urlParams["type_print"]} />, document.getElementById('root')
          );
          break;
        case "PrintKKCTaxInvoiceCoverNote":
          ReactDOM.render(
            <PrintKKCTaxInvoiceCoverNote tivList={urlParams["tivlist"]} />, document.getElementById('root')
          );
          break; 
        case "PrintKKCTaxInvoiceCoverNoteInsurer":
          ReactDOM.render(
            <PrintKKCTaxInvoiceCoverNoteInsurer tivList={urlParams["tivlist"]} />, document.getElementById('root')
          );
          break;   
        case "PrintSSTTaxInvoiceCoverNoteInsurer":
          ReactDOM.render(
            <PrintSSTTaxInvoiceCoverNoteInsurer tivList={urlParams["tivlist"]} />, document.getElementById('root')
          );
          break;  
        case "PrintZongTaxInvoiceCoverNoteInsurer":
            ReactDOM.render(
                <PrintZongTaxInvoiceCoverNoteInsurer tivList={urlParams["tivlist"]} />, document.getElementById('root')
            );
            break;              
        case "PrintKKCBillingNoteCompany":
          ReactDOM.render(
            <PrintKKCBillingNoteCompany ivList={urlParams["ivlist"]} dsList={urlParams["dslist"]}/>, document.getElementById('root')
          );
          break;
        case "PrintReportKKCPurchaseOrderSummary":
          ReactDOM.render(
            <PrintReportKKCPurchaseOrderSummary year={urlParams['year']} month={urlParams['month']} credit={urlParams['credit']} />, document.getElementById('root')
          );
          break;      
        case "PrintKKCBillingNoteInsurer":
          ReactDOM.render(
            <PrintKKCBillingNoteInsurer ivList={urlParams["ivlist"]} />, document.getElementById('root')
          );
          break;
        case "PrintSSTBillingNoteInsurer":
          ReactDOM.render(
            <PrintSSTBillingNoteInsurer bn={urlParams["bn"]} ivList={urlParams["ivlist"]} />, document.getElementById('root')
          );
          break;
        case "PrintShippingLabel":
          ReactDOM.render(
            <PrintShippingLabel idList={urlParams["idlist"]} docType={urlParams["doc"]} />, document.getElementById('root')
          );
          break;  
        case "PrintTLGTaxInvoiceCoverNoteInsurer":
            ReactDOM.render(
              <PrintTLGTaxInvoiceCoverNoteInsurer tivList={urlParams["tivlist"]} />, document.getElementById('root')
            );
            break;    
        case "PrintTLGInvoiceDoc":
          ReactDOM.render(
            <PrintTLGInvoiceDoc ivList={urlParams["iv"]} />, document.getElementById('root')
          );
          break;  
        case "PrintKKCDamagePartCheckList":
          ReactDOM.render(
            <PrintKKCDamagePartCheckList no={urlParams["number"]} carType={urlParams["car_type"]} workNo={urlParams["wo"]} />, document.getElementById('root')
          );
          break;
        case "PrintPurchaseReceivedDoc":
          ReactDOM.render(
            <PrintPurchaseReceivedDoc recordType={urlParams["type"]} poNo={urlParams["po"]} shop={decodeURIComponent(urlParams["shop"])} car_registration={decodeURIComponent(urlParams["car_registration"])} />, document.getElementById('root')
          );
          break;   
        case "PrintTwoPagesInvoiceDoc":
          ReactDOM.render(
            <PrintTwoPagesInvoiceDoc ivNo={urlParams['id']} />, document.getElementById('root')
          );
          break;
        case "PrintTwoPagesTaxInvoiceDoc":
          ReactDOM.render(
            <PrintTwoPagesTaxInvoiceDoc tivNo={urlParams['id']} />, document.getElementById('root')
          );
          break; 
        case "PrintTwoPagesCashBillDoc":
          ReactDOM.render(
            <PrintTwoPagesCashBillDoc cbNo={urlParams['id']} />, document.getElementById('root')
          );
          break;
        case "PrintTwoPagesReceiptDoc":
          ReactDOM.render(
            <PrintTwoPagesReceiptDoc rcNo={urlParams['id']} />, document.getElementById('root')
          );
          break;
        case "PrintTwoPagesPurchaseOrderDoc":
          ReactDOM.render(
            <PrintTwoPagesPurchaseOrderDoc poNo={urlParams['po']} />, document.getElementById('root')
          );
          break;  
          case "PrintReportTJYIncentiveExpenseInsurance":
          ReactDOM.render(
              <PrintReportTJYIncentiveExpenseInsurance year={urlParams['year']} month={urlParams['month']} payeeValue={urlParams['payee_value']} park={urlParams['park']} noPark={urlParams['no_park']} paidYet={urlParams['paid_yet']} noPaidYet={urlParams['no_paid_yet']} incentiveType={urlParams['incentive_type']} />, document.getElementById('root')
          );
          break;
        case "PrintReportCashflowRecord":
          ReactDOM.render(
            <PrintReportCashflowRecord cat={urlParams['cat']} year={urlParams['year']} month={urlParams['month']} day={urlParams['day']} />, document.getElementById('root')
          );
          break;    
        case "PrintWorkQCDoc":
          ReactDOM.render(
            <PrintWorkQCDoc workNo={urlParams["wo"]} />, document.getElementById('root')
          );
          break;
        case "PrintKKCWorkQCDoc":
          ReactDOM.render(
            <PrintKKCWorkQCDoc workNo={urlParams["wo"]} />, document.getElementById('root')
          );
          break;
        case "PrintTNKWorkCoverFileDoc":
          ReactDOM.render(
            <PrintTNKWorkCoverFileDoc workNo={urlParams["wo"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportPickup":
          ReactDOM.render(
            <PrintReportPickup year={urlParams["year"]} month={urlParams["month"]} name={decodeURIComponent(urlParams["name"])} />, document.getElementById('root')
          );
          break;
        case "PrintReportCommissionMechanic":
          ReactDOM.render(
            <PrintReportCommissionMechanic year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} empId={urlParams["empId"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportWork":
          renderReactDOM(
            <PrintReportWork {...urlParams} />,
            document.getElementById("root")
          );
          break;          
        case "PrintReportWorking":
          ReactDOM.render(
            <PrintReportWorking year={urlParams["year"]} month={urlParams["month"]} type={urlParams["type"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportWorkingDetail":
          ReactDOM.render(
            <PrintReportWorkingDetail year={urlParams["year"]} month={urlParams["month"]} empId={urlParams["empId"]} type={urlParams["type"]} fullname={decodeURIComponent(urlParams["fullname"])} taskclosed={decodeURIComponent(urlParams["taskclosed"])} taskamount={urlParams["taskamount"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportProductTransactionImport":
          ReactDOM.render(
            <PrintReportProductTransactionImport year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} groupId={urlParams["groupId"]} recordType={urlParams["recordType"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportProductTransactionRequestPurchase":
          ReactDOM.render(
            <PrintReportProductTransactionRequestPurchase year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} groupId={urlParams["groupId"]} recordType={urlParams["recordType"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportProductBalance":
          ReactDOM.render(
              <PrintReportProductBalance year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} groupId={urlParams["groupId"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportStockBalanceValue":
          ReactDOM.render(
              <PrintReportStockBalanceValue stockType={urlParams["stock_type"]} catId={urlParams["cat_id"]} subCatId={urlParams["sub_cat_id"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportStockCard":
          ReactDOM.render(
              <PrintReportStockCard year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportStockCardCost":
            renderReactDOM(<PrintReportStockCardCost year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} cat_id={urlParams["cat_id"]} itemnum={urlParams["itemnum"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />,document.getElementById('root')); 
            break;                
        case "PrintReportPOReceivedProduct":
          ReactDOM.render(
            <PrintReportPOReceivedProduct year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} shopId={urlParams["shopId"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} type={urlParams["type"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportSalesTax":
          ReactDOM.render(
            <PrintReportSalesTax year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} name={decodeURIComponent(urlParams["name"])} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportPostPayment":
          ReactDOM.render(
            <PrintReportPostPayment year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} name={decodeURIComponent(urlParams["name"])} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportAccountReceiable":
          ReactDOM.render(
            <PrintReportAccountReceiable year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} customerType={urlParams["customerType"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportAccountReceiableDetail":
          ReactDOM.render(
            <PrintReportAccountReceiableDetail year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} customerType={urlParams["customerType"]} type={urlParams["type"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportSummaryFixingWork":
          ReactDOM.render(
            <PrintReportSummaryFixingWork year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportFixingRefixed":
          ReactDOM.render(
            <PrintReportFixingRefixed year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break; 
        case "PrintReportUnfinishedWork":
          ReactDOM.render(
            <PrintReportUnfinishedWork />, document.getElementById('root')
          );
          break;     
        case "PrintReportUnfinishedWorkDetail":
          ReactDOM.render(
            <PrintReportUnfinishedWorkDetail paymentType={urlParams["paymentType"]} startDay={urlParams["startDay"]} endDay={urlParams["endDay"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportPostponeAppointment":
          ReactDOM.render(
            <PrintReportPostponeAppointment year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportSummaryWork":
          ReactDOM.render(
            <PrintReportSummaryWork year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;    
        case "PrintReportSummaryWorkDetail":
          ReactDOM.render(
            <PrintReportSummaryWorkDetail year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} type={urlParams["type"]} paymentType={urlParams["paymentType"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportSummary":
          ReactDOM.render(
            <PrintReportSummaryInsure type={urlParams["type"]} year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportWaitingQuotation":
          ReactDOM.render(
            <PrintReportWaitingQuotation customerType={urlParams["customerType"]} q={decodeURIComponent(urlParams["q"])} />, document.getElementById('root')
          );
          break;    
        case "PrintReportWorkDocPurchaseOrder":
          ReactDOM.render(
            <PrintReportWorkDocPurchaseOrder workNo={urlParams["wo"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportSummaryOT":
          ReactDOM.render(
            <PrintReportSummaryOT year={urlParams["year"]} month={urlParams["month"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportSummaryNormalAbsence":
          ReactDOM.render(
            <PrintReportSummaryNormalAbsence year={urlParams["year"]} month={urlParams["month"]} />, document.getElementById('root')
          );
          break;    
        case "PrintReportSummaryDeductionAbsence":
          ReactDOM.render(
            <PrintReportSummaryDeductionAbsence year={urlParams["year"]} month={urlParams["month"]} />, document.getElementById('root')
          );
          break;
        case "PrintSlipTableDoc":
          ReactDOM.render(
            <PrintSlipTableDoc year={urlParams["year"]} month={urlParams["month"]} emType={urlParams["emType"]}  resulttype={urlParams["resulttype"]} value={urlParams["value"]} start={urlParams["start"]} end={urlParams["end"]} />, document.getElementById('root')
          );
          break;    
        case "PrintReportConsumablesMaterial":
          ReactDOM.render(
            <PrintReportConsumablesMaterial year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} groupId={urlParams["groupId"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportColor":
          ReactDOM.render(
            <PrintReportColor year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportColorDetail":
          ReactDOM.render(
            <PrintReportColorDetail year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} description={decodeURIComponent(urlParams["description"])} productcode={urlParams["productcode"]} />, document.getElementById('root')
          );
          break;   
        case "PrintReportBalanceMaterial":
          ReactDOM.render(
            <PrintReportBalanceMaterial groupId={urlParams["groupId"]} />, document.getElementById('root')
          );
          break;
        case "PrintReportStockMixPaint":
          ReactDOM.render(
            <PrintReportStockMixPaint year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportUsageVolumeTransactionRecord":
          ReactDOM.render(
            <PrintReportUsageVolumeTransactionRecord year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportJobCostSheet":
          ReactDOM.render(
            <PrintReportJobCostSheet year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} criterion={urlParams["criterion"]} />, document.getElementById('root')
          );
          break;   
        case "PrintReportJobCostSheetDetail":
          ReactDOM.render(
            <PrintReportJobCostSheetDetail type={urlParams["type"]} workNo={urlParams["wo"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportQuotationMovement":
          ReactDOM.render(
            <PrintReportQuotationMovement year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
          );
          break;  
        case "PrintReportOutstandingIncomeSummary":
          ReactDOM.render(
            <PrintReportOutstandingIncomeSummary />, document.getElementById('root')
          );
          break;  
        case "PrintReportOutstandingIncomeSummaryDetail":
          ReactDOM.render(
            <PrintReportOutstandingIncomeSummaryDetail type={urlParams["type"]} insurerId={urlParams["insurerId"]} />, document.getElementById('root')
          );
          break;  
        case "PrintContinuousPaperConfig":
        case "PrintContinuousPaper":
          ReactDOM.render(
            <PrintContinuousPaperConfig pdfid={urlParams["pdfid"]} id={urlParams["id"]} />, document.getElementById('root')
          );
          break;  
        // case "PrintReportMechanicWork":
        //   ReactDOM.render(
        //     <PrintReportMechanicWork year={urlParams["year"]} month={urlParams["month"]} name={decodeURIComponent(urlParams["name"])} />, document.getElementById('root')
        //   );
        //   break;  
        case "PdfContinuousPaper":
          ReactDOM.render(
            <PdfContinuousPaper pdfid={urlParams["pdfid"]} id={urlParams["id"]} />, document.getElementById('root')
          );
          break;
        case "PrintSSTWorkQCDoc":
          ReactDOM.render(
            <PrintSSTWorkQCDoc workNo={urlParams["wo"]} dn={urlParams["dn"]} />, document.getElementById('root')
          );
          break;     
        case "PrintWCSParkingCarDoc":
          ReactDOM.render(
            <PrintWCSParkingCarDoc workNo={urlParams['wo']} />, document.getElementById('root')
          );
          break;
        case "PrintSSRParkingCarDoc":
            ReactDOM.render(
              <PrintWCSParkingCarDoc workNo={urlParams['wo']} showPrice={urlParams['show_price']==='false'}/>, document.getElementById('root')
            );
            break;        
        case "PrintWCSCheckingCarDoc":
          ReactDOM.render(
            <PrintWCSCheckingCarDoc workNo={urlParams['wo']} />, document.getElementById('root')
          );
          break;  
        case "PrintWCSFixingOrderDoc":
          ReactDOM.render(
            <PrintWCSFixingOrderDoc workNo={urlParams['wo']} />, document.getElementById('root')
          );
          break;  
        case "PrintBHLParkingCarDoc":
          ReactDOM.render(
            <PrintBHLParkingCarDoc workNo={urlParams['wo']} />, document.getElementById('root')
          );
          break;
        case "PrintBHLFixingListOnCarDoc":
          ReactDOM.render(
            <PrintBHLFixingListOnCarDoc workNo={urlParams['wo']} />, document.getElementById('root')
          );
          break;
        case "PrintBNPInvoiceDoc":
          ReactDOM.render(
            <PrintBNPInvoiceDoc ivNo={urlParams['iv']} />, document.getElementById('root')
          );
          break;
        case "PrintBNPTaxInvoiceDoc":
          ReactDOM.render(
            <PrintBNPTaxInvoiceDoc tivNo={urlParams['id']} />, document.getElementById('root')
          );
          break;
        case "PrintSSRInvoiceDoc":
          ReactDOM.render(
            <PrintSSRInvoiceDoc ivNo={urlParams['iv']} />, document.getElementById('root')
          );
          break;      
        case "PrintKKCPhotobook":
          ReactDOM.render(
            <PrintKKCPhotobook  workNo={urlParams['wo']}/>, document.getElementById('root')
          );
          break;   
        case "PrintReportEmployee":
          ReactDOM.render(
            <PrintReportEmployee status={urlParams['status']} query={urlParams['query']} />, document.getElementById('root')
          );
          break;  
        case "ReportTyreRepairPage":
          ReactDOM.render(
            <ReportTyreRepairPage />, document.getElementById('root')
          );
          break;   
        case "ReportTyreRetirePage":
          ReactDOM.render(
            <ReportTyreRetirePage />, document.getElementById('root')
          );
          break;
        case "ReportAssetVehiclePage":
          ReactDOM.render(
            <ReportAssetVehiclePage />, document.getElementById('root')
          );
          break;    
        case "PrintTyreRepairDoc":
          ReactDOM.render(
            <PrintTyreRepairDoc trNo={urlParams['trNo']} />, document.getElementById('root')
          );
          break;  
        case "PrintTyreRetireDoc":
          ReactDOM.render(
            <PrintTyreRetireDoc trNo={urlParams['trNo']} />, document.getElementById('root')
          );
          break;
        case "PrintPaymentNoteDoc":
            renderReactDOM(<PrintPaymentNoteDoc pnNo={urlParams["pn"]}/>,document.getElementById('root')); 
            break;    
        case "PrintGeneralSlipDoc":
          renderReactDOM(<PrintGeneralSlipDoc docNo={urlParams["doc_no"]} docName={urlParams["doc_name"]} showTaxInvoiceRefItem={urlParams["showTaxInvoiceRefItem"]} />,document.getElementById('root')); 
        break;   
        case "PrintVoucherDoc":
            renderReactDOM(<PrintVoucherDoc docNo={urlParams["doc_no"]} docName={urlParams["doc_name"]} showTaxInvoiceRefItem={urlParams["showTaxInvoiceRefItem"]} />,document.getElementById('root')); 
        break;         
        case "PrintCreditDebitDoc":
            renderReactDOM(<PrintCreditDebitDoc docNo={urlParams["doc_no"]} docName={urlParams["doc_name"]} showTaxInvoiceRefItem={urlParams["showTaxInvoiceRefItem"]} />,document.getElementById('root')); 
        break;  
        case "PrintDearTaxInvoiceDoc":
            renderReactDOM(
                <PrintDearTaxInvoiceDoc tivNo={urlParams['iv']} doc='taxinvoice_doc' param='tiv' header_style={urlParams['header_style']} />, document.getElementById('root')
            );            
        break;
        case "PrintDearPartDisposebyReturn":
            renderReactDOM(
                <PrintDearPartDisposebyReturn workNo={urlParams['wo']}  />, document.getElementById('root')
            );            
        break;
        case "PrintDeliveryCarDoc":
          renderReactDOM(
            <PrintDeliveryCarDoc workNo={urlParams["wo"]} dn={urlParams["dn"]} />, document.getElementById('root')
        );   
        break;
        case "PrintPGAAppointmentQueueDoc":
        ReactDOM.render(
            <PrintPGAAppointmentQueueDoc {...urlParams} />, document.getElementById('root')
        );
        break;    
        case "PrintPGAWorkCoverFileDoc":
        ReactDOM.render(
            <PrintPGAWorkCoverFileDoc mode={urlParams["mode"]} workNo={urlParams["wo"]} />, document.getElementById('root')
        );
        break;   
        case "PrintPGABorrowingBackupcarDoc":
        ReactDOM.render(
            <PrintPGABorrowingBackupcarDoc {...urlParams} />, document.getElementById('root')
        );
        break;      
        case "PrintReportAnalysisDeliveryEfficiency":
        ReactDOM.render(
            <PrintReportAnalysisDeliveryEfficiency year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
        );
        break;    
        case "PrintReportAnalysisWorkCustomCost":
        ReactDOM.render(
            <PrintReportAnalysisWorkCustomCost year={urlParams["year"]} month={urlParams["month"]} day={urlParams["day"]} isRange={urlParams["isRange"]} startDate={urlParams["start_date"]} endDate={urlParams["end_date"]} />, document.getElementById('root')
        );
        break;    
        case "PrintReceptionDoc":
        ReactDOM.render(
            <PrintReceptionDoc rcNo={urlParams["rc"]} shop={decodeURIComponent(urlParams["shop"])} car_registration={decodeURIComponent(urlParams["car_registration"])} />, document.getElementById('root')
        );
        break;                                   
      }
    }






// WEBPACK FOOTER //
// ./src/index-prod.js